import React from "react";
import PriceBlock from "./PriceBlock";
import OutletChip from "./OutletChip";
import { track } from "@/lib/analytics";

export default function PackageCard({ pkg }) {
  const isPopular = pkg.badge === "Most Popular";

  const scrollToDetails = (e) => {
    e.preventDefault();
    track("select_item", {
      item_list_name: "Packages",
      items: [{ item_id: pkg.slug || pkg.id || pkg.name || "", item_name: pkg.name || "", item_category: pkg.category_tag || "", price: Number(pkg.sale_price) || 0, quantity: 1 }],
    });
    document.getElementById(pkg.slug)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div
      className={`relative rounded-2xl p-5 flex flex-col border transition-all ${
        isPopular
          ? "glass-featured bg-[rgba(255,255,255,0.58)] backdrop-blur-xl"
          : "bg-[rgba(255,255,255,0.58)] backdrop-blur-xl border-[rgba(255,255,255,0.85)]"
      }`}
      style={{ boxShadow: "0 12px 32px rgba(90,60,160,0.08)" }}
    >
      <div className="flex items-center justify-between mb-3 min-h-[18px]">
        <span className="font-mono text-xs uppercase tracking-widest text-[#6c6c74]">
          {pkg.category_tag}
        </span>
        {pkg.badge && (
          <span
            className={`font-mono text-[10px] uppercase tracking-widest px-2 py-1 rounded-md ${
              isPopular
                ? "bg-brand-gradient text-white"
                : "border border-[rgba(28,28,32,0.08)] text-[#6c6c74]"
            }`}
          >
            {pkg.badge}
          </span>
        )}
      </div>

      <h3 className="text-[#1c1c20] text-[17px] font-[650] mb-1.5">{pkg.name}</h3>
      <p className="text-[#55555c] text-[15px] leading-[1.6] mb-5">{pkg.tagline}</p>

      {(() => {
        const comps = pkg.components || [];
        if (comps.length > 0) {
          const max = 6;
          const shown = comps.slice(0, max);
          const remaining = comps.length - shown.length;
          return (
            <div className="flex flex-wrap gap-1.5 mb-5">
              {shown.map((c) => (
                <OutletChip key={c.id} component={c} />
              ))}
              {remaining > 0 && (
                <span className="inline-flex items-center bg-[rgba(139,92,246,0.09)] border border-[rgba(139,92,246,0.2)] text-[#7c3aed] text-[12px] font-medium rounded-lg px-2 py-1 whitespace-nowrap">
                  +{remaining} more
                </span>
              )}
            </div>
          );
        }
        if (comps.length === 0 && pkg.name && pkg.name.startsWith("MSN")) {
          const match = pkg.name.match(/\+(\d+)/);
          const countLabel = match ? `+${match[1]} syndication sites` : "";
          return (
            <div className="flex flex-wrap gap-1.5 mb-5">
              <OutletChip component={{ id: pkg.id, name: "MSN", logo_url: pkg.logo_url || "", brand_logo_url: "" }} />
              {countLabel && (
                <span className="inline-flex items-center bg-[rgba(139,92,246,0.09)] border border-[rgba(139,92,246,0.2)] text-[#7c3aed] text-[12px] font-medium rounded-lg px-2 py-1 whitespace-nowrap">
                  {countLabel}
                </span>
              )}
            </div>
          );
        }
        return null;
      })()}

      <div className="mt-auto">
        {pkg.name === "DoFollow Authority Package" && (
          <p className="text-[12px] text-[#8e8e96] mb-1">$100 per DoFollow link</p>
        )}
        {pkg.name === "MSN +40" && (
          <p className="text-[12px] text-[#8e8e96] mb-1">Under $25 per DoFollow domain</p>
        )}
        <PriceBlock original={pkg.original_price} sale={pkg.sale_price} variant="card" />
        <a
          href={`#${pkg.slug}`}
          onClick={scrollToDetails}
          className="inline-flex items-center gap-1 text-[#7c3aed] hover:text-[#1c1c20] text-sm font-semibold transition-colors mt-3"
        >
          See details ↓
        </a>
      </div>
    </div>
  );
}